// extracted by css-extract-rspack-plugin
export default {"token":"AgentTasksToken-module__token__kMHqG","tokenContent":"AgentTasksToken-module__tokenContent__YpdM4","tokenCaret":"AgentTasksToken-module__tokenCaret__YAF4S"};